import { FC } from "react";
import Button from "../components/buttons/button";
import DefaultCardList from "../components/cards/lists/default";
import ReviewCard from "../components/cards/review";
import BookDemoForm from "../components/form/book-demo";
import { Main } from "../components/index";
import {
    AboutCards,
    AboutContainer,
    AboutTitle,
    SectionOurProducts,
} from "../components/index/sections/about.style";
import {
    FormBackplate,
    FormContainer,
    FormTitle,
    SectionForm,
} from "../components/index/sections/book.style";
import {
    HowCard,
    HowCardDescription,
    HowCards,
    HowContainer,
    HowImage,
    HowItWorksTextBlock,
    HowTitle,
    SectionHow,
    Spacer,
} from "../components/index/sections/how.style";
import {
    MethodArrows,
    MethodBlock1,
    MethodBlock2,
    MethodBlockArrow1,
    MethodBlockArrow2,
    MethodBlockArrow3,
    MethodBlockImage1,
    MethodBlockImage2,
    MethodBlockImage3,
    MethodBlockImage4,
    MethodBlockImage5,
    MethodBlockImage6,
    MethodBlockText,
    MethodContainer,
    MethodItems,
    MethodTitle,
    SectionMethodology,
} from "../components/index/sections/methodology.style";
import {
    ReviewsContainer,
    ReviewsTitle,
    SectionReviews,
} from "../components/index/sections/reviews.style";
import {
    Partner,
    Partners,
    SectionStart,
    StartCircle,
    StartContainer,
    StartContent,
    StartSubtitle,
    StartTitle,
} from "../components/index/sections/start.style";
import {
    SectionWhy,
    WhyCard,
    WhyCards,
    WhyCardText,
    WhyCardTitle,
    WhyCircleBottom,
    WhyCircleTop,
    WhyContainer,
    WhyTitle,
    WhyWrapper,
} from "../components/index/sections/why.style";

import {
    CaseStudy,
    OurCasesTitle,
    Scroller,
    SectionOurCases,
} from "../components/index/sections/our.cases";
import React from "react";
import { CaseStudies } from "../components/index/our.cases.data";
import Marquee from "react-fast-marquee";
import ProductCard from "../components/cards/product";
import ProductCardList from "../components/cards/lists/product_list";
import { FormattedMessage, useIntl } from "react-intl";

const IndexStartSection: FC = () => {
    return (
        <>
            <SectionStart>
                <StartContainer>
                    <StartContent>
                        <StartTitle>
                            <FormattedMessage id='index_page.start_section.title' />
                        </StartTitle>
                        <StartSubtitle>
                            <FormattedMessage id='index_page.start_section.subtitle' />
                        </StartSubtitle>
                        <Button to='/#demo' as='link'>
                            <FormattedMessage id='index_page.start_section.conversion_button_title' />
                        </Button>
                    </StartContent>
                    <StartCircle />
                </StartContainer>
                <Marquee gradient={false}>
                    <Partners>
                        <Partner>
                            <img
                                src={`${process.env.PUBLIC_URL}/index/partners/tealtechcapital.svg`}
                                width='100px'
                            />
                        </Partner>
                        <Partner>
                            <img
                                src={`${process.env.PUBLIC_URL}/index/press_logos/ard.png`}
                                width='100px'
                            />
                        </Partner>
                        <Partner>
                            <img
                                src={`${process.env.PUBLIC_URL}/index/partners/nca.svg`}
                                width='90px'
                            />
                        </Partner>
                        <Partner>
                            <img
                                src={`${process.env.PUBLIC_URL}/index/partners/sh.svg`}
                                width='100px'
                            />
                        </Partner>
                        <Partner>
                            <img
                                src={`${process.env.PUBLIC_URL}/index/partners/pap.svg`}
                                width='160px'
                            />
                        </Partner>
                        <Partner>
                            <img
                                src={`${process.env.PUBLIC_URL}/index/partners/tacc.svg`}
                                width='100px'
                            />
                        </Partner>
                        <Partner>
                            <img
                                src={`${process.env.PUBLIC_URL}/index/partners/smart_city.svg`}
                                width='150px'
                            />
                        </Partner>
                        <Partner>
                            <img
                                src={`${process.env.PUBLIC_URL}/index/partners/ceezer.svg`}
                                width='150px'
                            />
                        </Partner>
                        <Partner>
                            <img
                                src={`${process.env.PUBLIC_URL}/index/partners/lfca.svg`}
                                width='100px'
                            />
                        </Partner>
                    </Partners>
                </Marquee>
            </SectionStart>
        </>
    );
};

const IndexHowSection: FC = () => {
    return (
        <>
            <SectionHow id='how'>
                <HowContainer>
                    <HowTitle>
                        <FormattedMessage id='index_page.how_section.title' />
                    </HowTitle>
                    <HowCards>
                        <HowCard>
                            <HowImage src={`${process.env.PUBLIC_URL}/index/measure.png`} />
                            <Spacer />
                            <HowItWorksTextBlock>
                                <HowCardDescription>
                                    <b>
                                        <FormattedMessage id='index_page.how_section.paragraph_1.item_1.title' />
                                    </b>{" "}
                                    <FormattedMessage id='index_page.how_section.paragraph_1.item_1.description' />
                                    <br />
                                    <br />
                                    <b>
                                        <FormattedMessage id='index_page.how_section.paragraph_1.item_2.title' />
                                    </b>{" "}
                                    <FormattedMessage id='index_page.how_section.paragraph_1.item_2.description' />
                                </HowCardDescription>
                            </HowItWorksTextBlock>
                        </HowCard>
                        <HowCard>
                            <HowImage src={`${process.env.PUBLIC_URL}/index/reduce.png`} />
                            <HowItWorksTextBlock>
                                <HowCardDescription>
                                    <b>
                                        <FormattedMessage id='index_page.how_section.paragraph_2.item_1.title' />
                                    </b>{" "}
                                    <FormattedMessage id='index_page.how_section.paragraph_2.item_1.description' />
                                    <br />
                                    <br />
                                    <b>
                                        <FormattedMessage id='index_page.how_section.paragraph_2.item_2.title' />
                                    </b>{" "}
                                    <FormattedMessage id='index_page.how_section.paragraph_2.item_2.description' />
                                </HowCardDescription>
                            </HowItWorksTextBlock>
                        </HowCard>
                        <HowCard>
                            <HowImage src={`${process.env.PUBLIC_URL}/index/report.png`} />
                            <Spacer />
                            <HowItWorksTextBlock>
                                <HowCardDescription>
                                    <b>
                                        <FormattedMessage id='index_page.how_section.paragraph_3.item_1.title' />
                                    </b>{" "}
                                    <FormattedMessage id='index_page.how_section.paragraph_3.item_1.description' />
                                    <br />
                                    <br />
                                    <b>
                                        <FormattedMessage id='index_page.how_section.paragraph_3.item_2.title' />
                                    </b>{" "}
                                    <FormattedMessage id='index_page.how_section.paragraph_3.item_2.description' />
                                </HowCardDescription>
                            </HowItWorksTextBlock>
                        </HowCard>
                    </HowCards>
                </HowContainer>
            </SectionHow>
        </>
    );
};

const IndexProductsySection: FC = () => {
    const { formatMessage } = useIntl();
    return (
        <>
            <SectionOurProducts id='product'>
                <AboutContainer>
                    <AboutTitle>
                        <FormattedMessage id='index_page.products_section.title' />
                    </AboutTitle>
                    <AboutCards>
                        <ProductCardList>
                            <ProductCard
                                image='index/oftd-platform.svg'
                                text={formatMessage({
                                    id: "index_page.products_section.oftd_carbon_product.text",
                                })}
                                link='/#demo'
                            />
                            <ProductCard
                                image='index/oftd-finance.svg'
                                text={formatMessage({
                                    id: "index_page.products_section.oftd_finance_product.text",
                                })}
                                link='/#demo'
                            />
                        </ProductCardList>
                    </AboutCards>
                </AboutContainer>
            </SectionOurProducts>
        </>
    );
};

const IndexMethodologySection: FC = () => {
    return (
        <>
            <SectionMethodology>
                <MethodContainer>
                    <MethodTitle>
                        <FormattedMessage id='index_page.methodology_section.title' />
                    </MethodTitle>
                    <MethodItems>
                        <MethodBlock1>
                            <MethodBlockText>
                                <FormattedMessage id='index_page.methodology_section.text' />
                            </MethodBlockText>
                            <MethodArrows>
                                <MethodBlockArrow1 />
                                <MethodBlockArrow2 />
                                <MethodBlockArrow3 />
                            </MethodArrows>
                        </MethodBlock1>
                        <MethodBlock2>
                            <MethodBlockImage2
                                loading='lazy'
                                src={`${process.env.PUBLIC_URL}/index/GGP.png`}
                                alt='Greenhouse Gas Protocol'
                            />
                            <MethodBlockImage5
                                loading='lazy'
                                src={`${process.env.PUBLIC_URL}/index/iris.png`}
                                alt='Impact Reporting and Investment Standards'
                            />
                            <MethodBlockImage3
                                loading='lazy'
                                src={`${process.env.PUBLIC_URL}/index/SBT.png`}
                                alt='Science Based Targets'
                            />
                            <MethodBlockImage1
                                loading='lazy'
                                src={`${process.env.PUBLIC_URL}/index/SDG.png`}
                                alt='Sustainable Development Goals'
                            />
                            <MethodBlockImage4
                                loading='lazy'
                                src={`${process.env.PUBLIC_URL}/index/CDP.svg`}
                                alt='Carbon Disclosure Project'
                            />
                            <MethodBlockImage6
                                loading='lazy'
                                src={`${process.env.PUBLIC_URL}/index/TCFD.svg`}
                                alt='Task Force on Climate-related Financial Disclosures'
                            />
                        </MethodBlock2>
                    </MethodItems>
                </MethodContainer>
            </SectionMethodology>
        </>
    );
};

const IndexCasesSection: FC = () => {
    return (
        <SectionOurCases>
            <OurCasesTitle>
                <FormattedMessage id='index_page.our_cases_section.title' />
            </OurCasesTitle>
            <Scroller>
                {CaseStudies.map((caseStudy, index) => (
                    <CaseStudy key={index} href={"/" + caseStudy.path}>
                        <img src={caseStudy.logo} />
                    </CaseStudy>
                ))}
            </Scroller>
        </SectionOurCases>
    );
};

const IndexWhySection: FC = () => {
    return (
        <>
            <SectionWhy id='why'>
                <WhyContainer>
                    <WhyTitle>
                        <FormattedMessage id='index_page.why_section.title' />
                    </WhyTitle>
                    <WhyWrapper>
                        <WhyCards>
                            <WhyCard>
                                <WhyCardTitle>
                                    <FormattedMessage id='index_page.why_section.reason_1.title' />
                                </WhyCardTitle>
                                <WhyCardText>
                                    <FormattedMessage id='index_page.why_section.reason_1.text' />
                                </WhyCardText>
                            </WhyCard>
                            <WhyCard>
                                <WhyCardTitle>
                                    <FormattedMessage id='index_page.why_section.reason_2.title' />
                                </WhyCardTitle>
                                <WhyCardText>
                                    <FormattedMessage id='index_page.why_section.reason_2.text' />
                                </WhyCardText>
                            </WhyCard>
                            <WhyCard>
                                <WhyCardTitle>
                                    <FormattedMessage id='index_page.why_section.reason_3.title' />
                                </WhyCardTitle>
                                <WhyCardText>
                                    <FormattedMessage id='index_page.why_section.reason_3.text' />
                                </WhyCardText>
                            </WhyCard>
                            <WhyCard>
                                <WhyCardTitle>
                                    <FormattedMessage id='index_page.why_section.reason_4.title' />
                                </WhyCardTitle>
                                <WhyCardText>
                                    <FormattedMessage id='index_page.why_section.reason_4.text' />
                                </WhyCardText>
                            </WhyCard>
                            <WhyCard>
                                <WhyCardTitle>
                                    <FormattedMessage id='index_page.why_section.reason_5.title' />
                                </WhyCardTitle>
                                <WhyCardText>
                                    <FormattedMessage id='index_page.why_section.reason_5.text' />
                                </WhyCardText>
                            </WhyCard>
                            <WhyCard>
                                <WhyCardTitle>
                                    <FormattedMessage id='index_page.why_section.reason_6.title' />
                                </WhyCardTitle>
                                <WhyCardText>
                                    <FormattedMessage id='index_page.why_section.reason_6.text' />
                                </WhyCardText>
                            </WhyCard>
                        </WhyCards>
                        <WhyCircleTop />
                        <WhyCircleBottom />
                    </WhyWrapper>
                </WhyContainer>
            </SectionWhy>
        </>
    );
};

const IndexPressSection: FC = () => {
    const { formatMessage } = useIntl();
    return (
        <>
            <SectionReviews id='press'>
                <ReviewsContainer>
                    <ReviewsTitle>
                        <FormattedMessage id='index_page.press_section.title' />
                    </ReviewsTitle>
                    <DefaultCardList>
                        <ReviewCard
                            date=''
                            image='index/press_logos/ard.png'
                            imageHeight='34px'
                            text={
                                "Leveraging Offsetted's robust platform, companies can openly and credibly communicate their environmental impact."
                            }
                            externalHref='https://ardholdings.com/en/offsetted/'
                        />
                        <ReviewCard
                            date=''
                            image='index/press_logos/fintech.svg'
                            text={formatMessage({
                                id: "index_page.press_section.review_2.text",
                            })}
                            externalHref='https://c9k9c9v3.stackpathcdn.com/wp-content/uploads/2021/04/FNN-01-SG.svg?x64868'
                        />
                        <ReviewCard
                            date=''
                            image='index/press_logos/finextra.svg'
                            imageHeight='28px'
                            text={formatMessage({
                                id: "index_page.press_section.review_1.text",
                            })}
                            externalHref='https://www.finextra.com/pressarticle/94713/offsetted-unveils-esg-compliance-product'
                        />
                        <ReviewCard
                            date=''
                            image='index/press_logos/knowesg.svg'
                            imageHeight='28px'
                            text={formatMessage({
                                id: "index_page.press_section.review_3.text",
                            })}
                            externalHref='https://www.knowesg.com/regulators/offsetted-launches-esg-compliance-solution-at-sff-2022-02112022'
                        />
                        <ReviewCard
                            date=''
                            image='index/press_logos/beststrtpeu.png'
                            imageHeight='46px'
                            text={formatMessage({
                                id: "index_page.press_section.review_4.text",
                            })}
                            externalHref='https://beststartup.eu/22-top-big-data-startups-and-companies-in-hamburg/'
                        />
                        <ReviewCard
                            date=''
                            image='index/press_logos/hamburg_startups.svg'
                            text={formatMessage({
                                id: "index_page.press_section.review_5.text",
                            })}
                            externalHref='https://www.hamburg-startups.net/nca-startups-fuer-klimaschutz-hoehere-umsaetze-und-wohlbefinden/'
                        />
                        <ReviewCard
                            date=''
                            image='index/press_logos/sh.svg'
                            text={formatMessage({
                                id: "index_page.press_section.review_6.text",
                            })}
                            externalHref='https://wimikiel.com/2022/06/24/innovativ-und-ideenreich-das-sind-die-siegerinnen-und-sieger-unseres-6-startup-camps/'
                        />
                    </DefaultCardList>
                </ReviewsContainer>
            </SectionReviews>
        </>
    );
};

const IndexPage: FC = () => {
    return (
        <Main>
            <IndexStartSection />
            <IndexHowSection />
            <IndexProductsySection />
            <IndexMethodologySection />
            <IndexCasesSection />
            <IndexWhySection />
            <IndexPressSection />
            <SectionForm id='demo'>
                <FormContainer>
                    <FormBackplate>
                        <FormTitle>
                            <FormattedMessage id='index_page.form.title' />
                        </FormTitle>
                        <BookDemoForm id='main-landing-form' />
                    </FormBackplate>
                </FormContainer>
            </SectionForm>
        </Main>
    );
};

export default IndexPage;
